/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DashboardIcon from './baseline_folder_open_black_24dp.png';
import AttributesIcon from './baseline_format_list_bulleted_black_24dp.png';
import EntityTypesIcon from './baseline_grid_on_black_24dp.png';
import GroupsIcon from './baseline_group_black_24dp.png';
import UsersIcon from './baseline_person_black_24dp.png';
import ImportconfigIcon from './baseline_import_contacts_black_24dp.png';
import ImportIcon from './baseline_import_export_black_24dp.png';
import LogoutIcon from './baseline_exit_to_app_black_24dp.png';

import './Menucontainer.css';

/**
 * Represents the menucontainer component that appears inside the menu on
 * the left side.
 */

export default class Menucontainer extends Component {
   
    /**
     * Properties.
     */

    static propTypes = {
        context:                PropTypes.object.isRequired,
        onLogout:               PropTypes.func.isRequired,
        onMenupointSelected:    PropTypes.func.isRequired
    }

    /**
     * Default state.
     */

    state = {
        selected:           null
    }

    /**
     * Selects the first menupoint.
     */

    selectFirstMenupoint = () => {

        // First menupoint

        let menupoint = 'dashboard';

        // Storing the first menupoint as a selected menupoint

        this.setState({ selected: menupoint });

        // Menupoint selected

        this.props.onMenupointSelected(menupoint);
    }

    /**
     * Event that fires when the user selects a menupoint.
     * 
     * @param   {String}    menupoint   selected menupoint
     */

    _selectMenupoint = (menupoint) => {

        // Storing the selected menupoint

        this.setState({ selected: menupoint });

        // Checking the selected menupoint

        if (menupoint === 'logout') {

            // Logging out

            this.props.onLogout();
        } else {

            // Menupoint selected

            this.props.onMenupointSelected(menupoint);
        }
    }

    /**
     * Clears the menupoint selection.
     */

    clearMenupointSelection = () => {

        // Storing the selected menupoint

        this.setState({ selected: null });        
    }

    /** 
     * Menucontainer renderer.
     */

    render() {

        // Selectable menupoints

        let menu = [
            { id: 'dashboard', icon: DashboardIcon },
            { id: 'attributes', icon: AttributesIcon, admin: true },
            { id: 'entitytypes', icon: EntityTypesIcon, admin: true },
            { id: 'groups', icon: GroupsIcon, admin: true },
            { id: 'users', icon: UsersIcon, admin: true },
            { id: 'importconfig', icon: ImportconfigIcon, admin: true },
            { id: 'import', icon: ImportIcon, admin: true },
            { id: 'logout', icon: LogoutIcon },
        ];

        return (
            <div className="menucontainer">

                {/* Menupoints */}

                { menu.map((item, index) =>
                    this.props.context.user && ((this.props.context.user.admin && item.admin) || !item.admin) &&
                        <div key={index} className={`horizontal center ${this.state.selected === item.id ? 'menucontainer-menupointselected' : 'menucontainer-menupoint'}`} onClick={this._selectMenupoint.bind(this, item.id)}>
                            <img alt="Menupoint" src={item.icon} className="menucontainer-menuicon" />
                            <div className="menucontainer-menupoint-label">{this.props.context.locale.menu[item.id]}</div>
                        </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Menucontainer/Menucontainer.js